import React from 'react';
import fields from '@/constants/fields';
import SelectableRow from '@/components/table/SelectableRow';
import LookupName from '../containers/LookupName';
import LookupDescription from '../containers/LookupDescription';
import LookupDeleteTableCell from '../containers/LookupDeleteTableCell';
import LookupUri from '../containers/LookupUri';
import LookupOptionWarningCell from './LookupOptionWarningCell';

const LookupVocabularyRow = ({
  lookupItemUUID,
  canEdit,
  validationWarnings,
  showWarning,
}) => {
  const warning = validationWarnings.find((e) => (
    e.context.lookupItemUUID === lookupItemUUID && e.fields.includes(fields.NAME)));

  return (
    <SelectableRow warning={warning && showWarning}>
      {showWarning && (<LookupOptionWarningCell warning={warning} />)}
      <LookupName lookupItemUUID={lookupItemUUID} />
      <LookupDescription lookupItemUUID={lookupItemUUID} />
      <LookupUri lookupItemUUID={lookupItemUUID} />
      {canEdit && (<LookupDeleteTableCell lookupItemUUID={lookupItemUUID} />)}
    </SelectableRow>
  );
};

export default LookupVocabularyRow;
